import breadcrumbsItem from './breadcrumbs__item';
export default breadcrumbsItem;